export default "__VITE_ASSET__QAa641Y3__"